export default __webpack_public_path__ + "static/media/benefit1.dfbb5376.png";